module.exports = __webpack_public_path__ + "media/campaingNew_web.b1ec04f2.mp4";